<template>
  <div id="relListCom">
    <div v-if="pResumoComissoes.porCategoria && pResumoComissoes.porCategoria.length > 0">
      <!--parametros: {{parametros}}-->
      <b-row class="pt-2 topRelCom">
        <b-col class="col-md-4 title pl-3 relComMes" v-if="pResumoComissoes.valorMes">{{pResumoComissoes.valorMes.mes}}</b-col>
        <b-col class="col-md-4 title pl-3 relComMes" v-else>-</b-col>
        <b-col class="col-md-8 title text-right relComVal" v-if="pResumoComissoes.valorMes">Valor total: {{this.formatPrice(pResumoComissoes.valorMes.valor)}} </b-col>
        <b-col class="col-md-8 title text-right relComVal" v-else>-</b-col>
      </b-row>
      <b-col class="topRelCom p-0">
        <b-alert show variant="warning" class="mt-3" v-if="noticeAssina">
          <b-row>
            <b-col class="col-md-8 txtLeft p-0" id="pergAceite">
              <!-- {{ pResumoComissoes.aceite.aceita === 0 ? 'Aceitar comissão?' : ''}} -->
                Aceitar comissão?
            </b-col>
            <b-col class="col-md-2 pr-0 txtRight btnsAceite">
              <b-button size="sm" @click="naoAceita()">Não</b-button>
            </b-col>
            <b-col class="col-md-2 pr-0 txtRight btnsAceite">
              <b-button size="sm" @click="enviar(1, '')">Sim</b-button>
            </b-col>
          </b-row>
        </b-alert>
        <b-alert class="txtLeft mt-3" v-if="noticeInfo" show variant="info">Comissão aceita em {{pResumoComissoes.aceite.dataAceite}}</b-alert>
        <b-alert class="txtLeft mt-3" v-if="noticeBackoffice" show variant="light">{{pResumoComissoes.aceite.mensagemRejeicao}}</b-alert>
      </b-col>
      <b-modal
        v-model="modalMotivoRecusa"
        header-bg-variant="headerBgVariant"
        header-text-variant="headerTextVariant"
        id="modal-center"
        centered title="Motivo">
        <p class="my-4">
          <b-form-textarea
            required minlength="10"
            v-validate="'min:10'"
            data-vv-as="field"
            id="textarea-small"
            name="motivo_recusa"
            size="sm"
            v-model="motivo"
            placeholder="Insira o por quê de estar em desacordo com o valor."
            class="mb-3"
          ></b-form-textarea>
          <span v-if="errors.has('motivo_recusa')" style="color: #7c000a" class="mt-2"><b>Escreva pelo menos 10 caracteres para avaliação do backoffice.</b></span>
        </p>
        <template slot="modal-footer" slot-scope="{ ok, cancel}">
          <b-button size="sm" variant="primary" @click="cancel()">
            Cancelar
          </b-button>
          <b-button size="sm" variant="secondary" :disabled="motivo.length <= 10" @click="enviar(0, motivo)">
            Enviar
          </b-button>
        </template>
      </b-modal>
      <hr>
      <section class="card mt-3">
        <b-card-header
          :header="'Resumo'"
          header-text-variant="white"
          :style="cor"
        />
        <b-card class="shadow">
          <b-card-body  class="p-0">
            <b-table bordered striped :items="pResumoComissoes.porCategoria" :fields="fieldsCategoria" v-if="pResumoComissoes.porCategoria && pResumoComissoes.porCategoria.length > 0"></b-table>
            <span v-else>
              Não há itens para este filtro
            </span>
          </b-card-body>
          <div slot="footer" class="footer txtRight mr-4" v-if="pResumoComissoes.porCategoria && pResumoComissoes.porCategoria.length > 0"><b>Total: {{this.formatPrice(totalCategoria)}}</b></div>
        </b-card>
      </section>
      <section class="card mt-3">
        <b-card-header
          :header="'Extrato'"
          header-text-variant="white"
          :style="cor"
        />
        <b-card class="shadow">
          <b-card-text  class="table pt-0 pb-0">
            <b-table bordered striped :items="pResumoComissoes.extrato" :fields="fieldsExtrato" v-if="pResumoComissoes.extrato && pResumoComissoes.extrato.length > 0">
              <template slot="mobile" slot-scope="row">
                <div class="form-row mb-1">
                  <strong>Cliente:</strong> {{toCapitalize(row.item.fantasia)}}
                </div>
                <div class="form-row mb-1">
                  <div class="col-md-6"><strong>NF:</strong> {{row.item.notaFiscal}}</div>
                  <div class="col-md-6 txtRight"><strong>Emissão:</strong> {{row.item.dataEmissao}}</div>
                </div>
                <div class="form-row mb-1">
                  <div class="col-md-6"><strong>Base:</strong> {{formatPrice(row.item.valorBase)}}</div>
                  <div class="col-md-6 txtRight"><strong>Valor Comissão:</strong> {{formatPrice(row.item.valorComissao)}}</div>
                </div>
                <div class="form-row mb-1">
                  <div class="col-md-6"><strong>Percentual:</strong> {{row.item.percentual}}</div>
                  <div class="col-md-6 txtRight"><strong>Categoria:</strong> {{toCapitalize(row.item.categoria)}}</div>
                </div>
              </template>
            </b-table>
            <span v-else>
              Não há itens para este filtro
            </span>
          </b-card-text>
          <div slot="footer" class="footer txtRight mr-4" v-if="pResumoComissoes.extrato && pResumoComissoes.extrato.length > 0"><b>Total: {{this.formatPrice(totalExtrato)}}</b></div>
        </b-card>
      </section>
      <section class="card mt-3" v-if="false">
        <b-card class="shadow">
          <b-card-body>
            <GChart
              type="ColumnChart"
              :data="chartData"
              :options="chartOptions"
            />
          </b-card-body>
        </b-card>
      </section>
    </div>
    <BlockUI v-if="blockUI.visibility" :message="blockUI.message">
      <spinner-vue  id="modal-xl" ></spinner-vue>
    </BlockUI>
  </div>
</template>
<script>
  import relatoriosService from '@/services/relatorios'
  import ToastVue from '../layouts/toastVue'
  import spinnerVue from '@/components/items/SpinnerVue'
  import { GChart } from 'vue-google-charts'
  // import { broadcastServer } from '@/main'

  export default {
    components: {
      ToastVue,
      spinnerVue,
      GChart
    },
    props: {
      pResumoComissoes: {
        valorMes: {
          mes: '',
          valor: 0
        },
        extrato: [],
        porCategoria: [],
        aceite: {},
        mes: 0,
        ano: 0
      },
      pObjClientes: {},
      pObjPaginacao: {}
    },
    data () {
      return {
        cor: '',
        // resumoComissoes: [],
        // resumoComissoesCategorias: [],
        totalResumo: 0,
        totalResumoCategoria: 0,
        periodoSelecionado: '',
        resumoComissoes: '',
        totalCategoria: '',
        totalExtrato: '',
        valorMes: '',
        chartData: [
          ['Year', 'Sales'],
          ['Março', 1000],
          ['Abril', 1170]
        ],
        chartOptions: {
          chart: {
            title: 'Company Performance',
            subtitle: 'Sales, Expenses, and Profit: 2014-2017'
          }
        },
        modalMotivoRecusa: false,
        blockUI: {
          message: '',
          visibility: false
        },
        noticeAssina: false,
        noticeInfo: false,
        noticeBackoffice: false,
        tipoPedido: [],
        statusSelecionado: {},
        clientes: [],
        modes: ['single'],
        selectMode: 'single',
        selected: [],
        motivo: '',
        assinaComissao: false,
        parametros: {
          mes: 0,
          ano: 0,
          aceita: 0,
          motivo: ''
        },
        fieldsPeriodo: [
          {
            key: 'periodo',
            label: 'Periodo',
            sortable: false,
            class: 'txtCenter',
            isActive: true
          },
          {
            key: 'valor',
            label: 'Valor',
            class: 'txtRight',
            isActive: true,
            formatter: this.formatPrice
          }
        ],
        fieldsCategoria: [
          {
            key: 'categoria',
            label: 'Categoria',
            sortable: false,
            class: 'txtLeft',
            formatter: this.toCapitalize
          },
          {
            key: 'valor',
            label: 'Valor',
            sortable: false,
            class: 'txtRight',
            formatter: this.formatPrice
          }
        ],
        fieldsExtrato: [
          {
            key: 'fantasia',
            label: 'Cliente',
            sortable: true,
            class: 'relComFant txtLeft',
            formatter: this.toCapitalize
          },
          {
            key: 'dataEmissao',
            label: 'Data Emissão',
            sortable: false,
            class: 'relComEmi txtCenter'
          },
          {
            key: 'notaFiscal',
            label: 'NF',
            sortable: false,
            class: 'relComNF txtCenter'
          },
          {
            key: 'valorBase',
            label: 'Base',
            sortable: false,
            class: 'relComBase txtCenter',
            formatter: this.formatPrice
          },
          {
            key: 'percentual',
            label: '%',
            sortable: false,
            class: 'relComPerc txtCenter'
          },
          {
            key: 'categoria',
            label: 'Categoria',
            sortable: false,
            class: 'relComCateg txtLeft',
            formatter: this.toCapitalize
          },
          {
            key: 'valorComissao',
            label: 'Valor Comissão',
            sortable: false,
            class: 'relComVCom txtRight',
            formatter: this.formatPrice
          },
          {
            label: '',
            key: 'mobile',
            class: 'relComMobile txtLeft'
          }
        ]
      }
    },
    watch: {
      pResumoComissoes: function (newVal, oldVal) { // watch it
        if (newVal.aceite.aceita === 1) {
          this.noticeAssina = false
          this.noticeInfo = true
          this.noticeBackoffice = false
        } else if (newVal.aceite.aceita === 0 && newVal.aceite.mensagemRejeicao !== '') {
          this.noticeAssina = true
          this.noticeInfo = false
          this.noticeBackoffice = true
        } else if (newVal.aceite.aceita === 0 && newVal.aceite.mensagemRejeicao === '') {
          this.noticeAssina = true
          this.noticeInfo = false
          this.noticeBackoffice = false
        }
        this.mostraAceiteComissao()
        let extrato = newVal.extrato.sort(function (a, b) {
          return a.dataEmissaoOrdem - b.dataEmissaoOrdem
        })
        this.parametros.mes = this.pResumoComissoes.mes
        this.parametros.ano = this.pResumoComissoes.ano
        this.pResumoComissoes.extrato = extrato
        this.totalCategoria = newVal.porCategoria.reduce(function (r, a) { return r + a.valor }, 0)
        this.totalExtrato = newVal.extrato.reduce(function (r, a) { return r + a.valorComissao }, 0)
      }
    },
    created () {
      this.cor = {'background-color': `#${localStorage.getItem('corApp')}`}
      setTimeout(this.mostraAceiteComissao, 100)
    },
    methods: {
      mostraAceiteComissao: function () {
        let dataCorrente = new Date().getMonth() + 1
        let anoCorrente = new Date().getFullYear()
        let mesAnterior = dataCorrente - 1
        let dataSelecionada = this.pResumoComissoes.mes
        let anoSelecionado = JSON.parse(this.pResumoComissoes.ano)
        if ((dataCorrente === dataSelecionada) && (anoCorrente === anoSelecionado)) {
          this.noticeAssina = false
        } else if ((dataSelecionada === mesAnterior) && (anoCorrente === anoSelecionado)) {
          this.noticeAssina = true
        } else {
          this.noticeAssina = false
        }
        // } else this.noticeAssina = !((dataCorrente < dataSelecionada) && (anoCorrente === anoSelecionado))
      },
      enviar: function (aceita, motivo) {
        this.blockUI.message = 'Enviando dados, aguarde...'
        this.blockUI.visibility = true
        this.parametros.mes = this.pResumoComissoes.mes
        this.parametros.ano = this.pResumoComissoes.ano
        this.parametros.aceita = aceita
        this.parametros.motivo = motivo
        console.log(JSON.stringify(this.parametros))
        relatoriosService.enviar(this.parametros).then(response => {
          console.log(response.data)
          this.pResumoComissoes = response.data
          this.pResumoComissoes.mes = this.parametros.mes
          this.pResumoComissoes.ano = this.parametros.ano
        }).catch(error => {
          console.log(error)
          this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger')
        }).finally(() => {
          this.blockUI.visibility = false
          this.modalMotivoRecusa = false
        })
      },
      naoAceita: function () {
        this.modalMotivoRecusa = true
      },
      enviarMotivoRecusa: function () {
        // let objectPost = {mes: '', ano: '', aceita: 0, motivo: ''}
      },
      assinatura: function () {
        this.noticeAssina = false
        this.noticeInfo = false
        this.noticeBackoffice = false
        let semMotivo = this.aceitaComissao.mensagemRejeicao = ''
        if (this.aceitaComissao.aceita === 0) {
          this.noticeAssina = true
        } else if (this.aceitaComissao.aceita === 0 && semMotivo) {
          this.noticeAssina = true
          this.noticeBackoffice = true
        } else {
          this.noticeBackoffice = true
        }
      },
      formatPrice (value) {
        let val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      },
      toCapitalize: function (value) {
        return value.replace(/\w\S*/g, function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        })
      }
    }
  }
</script>
<style scoped>
  .table{
    overflow-y: auto;
    position: relative;
    min-height: 82px;
    max-height: 350px;
    font-size: 14px;
  }
  .imgTable {
    width: 50px !important;
  }
  #pergAceite {
    line-height: 2;
  }
</style>



// WEBPACK FOOTER //
// src/components/items/relatoriosComissoesVue.vue